import styled from 'styled-components';

export const SectionContainer = styled.div`
  background-color: #1a1a1a;
  padding: 40px 0;
  width: 100%;

  @media (max-width: 768px) {
    padding: 40px 0 56px 0;
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 1369px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0;
    max-width: 340px;
    gap: 0px;
  }

  h1 {
    color: #c3c3c3;
    font-size: 32px;
    font-style: normal;
    font-weight: 275;
    line-height: 40px;

    @media (max-width: 768px) {
      font-size: 18px;
      line-height: 32px;
      width: 250px;
    }
  }

  span {
    color: #f16024;
  }
`;

export const StyledHr = styled.hr`
  flex: 1;
  border: 1px solid #c3c3c3;
  margin: 0 20px;

  @media (max-width: 768px) {
    margin: 0;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: left;
  margin-top: 10px;
  max-width: 1180px;
  width: 100%;
  margin: 64px auto;

  @media (max-width: 768px) {
    flex-direction: column;
    max-width: 340px;
    margin: 24px auto 0;
    padding: 0;
    gap: 40px;
  }
`;

export const TextBox1 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  h2 {
    font-family: Barlow;
    font-size: 24px;
    font-style: normal;
    font-weight: 300;
    line-height: 32px;
    color: #fcfcfc;
  }

  p {
    font-family: 'Open Sans';
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px;
    color: #c3c3c3;

    span,
    a {
      color: #f16024;
    }

    @media (max-width: 768px) {
      line-height: 32px;
      margin-bottom: 20px;
    }
  }

  ul {
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 32px;
    padding-left: 30px;
    color: #c3c3c3;

    @media (max-width: 768px) {
      line-height: 32px;
      margin-bottom: 26px;
    }

    span {
      color: #f16024;
    }
  }
`;
